export enum FileType {
    BACKGROUND = 'backgrounds',
    PUBLICITY = 'publicities',
    SLIDES = 'slides',
    PROFILE_PICTURE = 'profile_pictures',
    LINK_PREVIEW = 'link_preview',
    DOCUMENTS = 'documents',
    LOGO = 'logos',
    IMAGES = 'images',
    FAVICONS = 'favicons'
}